// extracted by mini-css-extract-plugin
export var checkbox = "_8w-0";
export var circle = "_8w-3";
export var horizontalContainer = "_8w-7";
export var sm = "_8w-5";
export var switch0 = "_8w-2";
export var switchDisabled = "_8w-8";
export var switchEnabled = "_8w-1";
export var textSwitchContainer = "_8w-9";
export var textSwitchOption = "_8w-a";
export var textSwitchOptionSelected = "_8w-b";
export var verticalContainer = "_8w-6";
export var xs = "_8w-4";